import { useEffect, useState, useRef } from 'react';
import toast from 'react-hot-toast';
import Flatpickr from "react-flatpickr";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";

import DataMes from '../componentes/DataMes';
import TituloSessao from '../componentes/TituloSessao';
import BarraBuscaComTodasUnidades from '../componentes/BarraBuscaComTodasUnidades';
import BlocoEItensFormularioAcompanhamento from '../componentes/BlocoEItensFormularioAcompanhamento';
import AssinaturasFormularioAcompanhamento from '../componentes/AssinaturasFormularioAcompanhamento';

import {
    servGetAllOpcaoRespostaFormularioAcompanhamento,
    servPostFormularioAcompanhamento,
    servVerificaMesEnvio,
    servVerificaDuplicidade
}
    from '../servicos/servicosEmRotasPrivadas/formulario_acompanhamento';
import { servGetBlocoAndItensByEstabelecimendoId } from '../servicos/bloco_item_formulario';
import { servDownloadFormularioAcompanhamento } from '../servicos/servicosEmRotasPrivadas/download';

import smartToast from '../util/smart_toast';
import TelaInformativa from './TelaInformativa';
import { regrasDeNegocio } from '../config/regrasDeNegocio';
import { toastErrorFromResponse } from '../util/utilitarios';

function CriaFormularioAcompanhamento() {

    console.log('###Iniciando CriaFormularioAcompanhamento###');

    const [exibirTelaInformativa, setExibeTelaInformativa] = useState(false)
    const [perguntasAgrupBloco, setPerguntasAgrupBloco] = useState(null)
    const [estabelecimento, setEstabelecimento] = useState(null)
    const [dataVisita, setDataVisita] = useState('')
    const [mesReferencia, setMesReferencia] = useState('')
    const [envioValido, setEnvioValido] = useState(null)
    const [opcoesRespostas, setOpcoesRespostas] = useState(null)
    // Me pediram pra fixar esses dois ids abaixo, no dia que tiver mais de uma opcao nao eh
    // mais necessario fazer isso
    const objetoId = 1
    const instrumentoId = 1

    const [perguntasRespondidas, setPerguntasRespondidas] = useState(null)
    const [assinaturas, setAssinaturas] = useState(null);

    // verifica data e impoe limites
    useEffect(() => {

        const verificaMesEnvio = async () => {
            try {

                await toast.promise(
                    servVerificaMesEnvio(estabelecimento.id, mesReferencia),
                    { loading: 'Verificando se mês de envio é válido...' }
                );

                return true

            } catch (erro) {
                toastErrorFromResponse(erro);
                return false
            }
        }

        const verificaDuplicidade = async () => {
            try {

                await smartToast(
                    servVerificaDuplicidade(estabelecimento.id, mesReferencia),
                    {
                        loadingMessage: 'Verificando se a unidade já enviou relatório no mês selecionado...',
                        apenasLoading: true
                    },
                );

                return true

            } catch (erro) {
                toastErrorFromResponse(erro);
                return false
            }
        }

        const validacaoFinal = async () => {

            const [validaDuplicidade, validaMes] = await Promise.all([
                verificaDuplicidade(),
                verificaMesEnvio()
            ])

            if (validaDuplicidade && validaMes) {

                setPerguntasRespondidas(null)
                setPerguntasAgrupBloco(null)

                try {

                    const itensFormularioDaApi = await smartToast(
                        servGetBlocoAndItensByEstabelecimendoId(estabelecimento.id),
                        {
                            loadingMessage: 'Buscando perguntas relacionadas a unidade selecionada...',
                            apenasLoading: true
                        },
                    );

                    setPerguntasAgrupBloco(itensFormularioDaApi);
                    setPerguntasRespondidas(itensFormularioDaApi.flatMap(bloco =>
                        bloco.itens.map(({ descricao, nota, ...item }) => ({
                            ...item,
                            bloco: bloco.bloco,
                            blocoId: bloco.blocoId,
                            respostaId: null,
                            observacao: null
                        }))
                    ));

                } catch (erro) {
                    toastErrorFromResponse(erro);
                }
                // Validei o estabelecimento, o mês, busquei as perguntas, agora posso colocar as informações na tela.
                setEnvioValido(true)
            } else {
                // Alguma validação não passou, limpando tela para impedir qualquer tentativa de envio
                setEnvioValido(false)
            }
        }

        if (mesReferencia && estabelecimento) validacaoFinal()

    }, [mesReferencia, estabelecimento]);

    // Busca opções de resposta dos itens (perguntas)
    useEffect(() => {

        const getAllOpcaoRespostaFormularioAcompanhamento = async () => {
            try {
                const respostasDaApi = await servGetAllOpcaoRespostaFormularioAcompanhamento()
                setOpcoesRespostas(respostasDaApi.data)
            } catch (erro) {
                toastErrorFromResponse(erro);
            }
        }

        getAllOpcaoRespostaFormularioAcompanhamento()

    }, []);

    const respondeItem = (id, campo, valor) => {
        setPerguntasRespondidas(prev =>
            prev.map(item =>
                item.modeloId === id
                    ? { ...item, [campo]: valor }
                    : item
            )
        );
    };

    const validacaoPreEnvio = (itensRespondidos) => {

        if (!estabelecimento) throw new Error('Estabelecimento não selecionado')
        if (!dataVisita) throw new Error('Data de visita não selecionada');

        if (itensRespondidos.some(item => item.respostaId === null)) throw new Error('Há perguntas não respondidas');

        itensRespondidos.find(item => {
            const respostaMapeamento = opcoesRespostas.find(r => r.id === item.respostaId);
            if (['NÃO', 'PARCIAL'].includes(respostaMapeamento.resposta) &&
                (!item.observacao || item.observacao.trim() === '')) {
                throw new Error(`A pergunta ${item.blocoId}.${item.modeloCodigo} requer uma observação, pois a resposta aponta uma inconformidade.`);
            }
        });

    };

    async function handlerSubmit(event) {

        event.preventDefault();

        const formData = new FormData(event.target);
        const resumoFragilidadesDetectadas = formData.get('resumoFragilidadesDetectadas');

        const formularioAcompanhamento = {
            'estabelecimentoId': estabelecimento.id,
            'dataVisita': dataVisita,
            'mesReferencia': mesReferencia,
            'instrumentoId': instrumentoId,
            'objetoId': objetoId,
            'resumoFragilidadesDetectadas': resumoFragilidadesDetectadas,
            'assinaturas': assinaturas,
            'itensDoFormulario': perguntasRespondidas
        };

        try {
            validacaoPreEnvio(perguntasRespondidas)
        } catch (erro) {
            toast.error(erro.message);
            return;
        }

        try {

            const responseCriacaoFormulario = await smartToast(
                servPostFormularioAcompanhamento(formularioAcompanhamento),
                {
                    loadingMessage: 'Criando Relatório...',
                    apenasLoading: false
                },
            );

            try {
                servDownloadFormularioAcompanhamento(responseCriacaoFormulario.data.formularioAcompanhamentoId)
            } catch (error) {
                toastErrorFromResponse(error);
            }

            setExibeTelaInformativa(true)

        } catch (erro) {
            toastErrorFromResponse(erro);
        }

    }

    if (exibirTelaInformativa) {
        return <TelaInformativa cabecalho='Formulário criado com sucesso'
            mensagem='Clique no botão abaixo para retornar à tela de cadastro de Formulários'
            pathRedirect={null}
            buttonMessage='Voltar'
            urlExterna={false} />;
    }

    return (

        <div className='container'>
            <TituloSessao titulo='Relatório de Acompanhamento das unidades' barraDecorativa={false} centralizaTitulo={true} />
            <form className='d-flex flex-column gap-3 mb-3' onSubmit={handlerSubmit}>
                <div className='div-flex-com-borda gap-3 p-3'>
                    <div className='d-flex flex-column flex-md-row gap-2 align-items-center'>
                        <div className='col-12 col-md-2'>
                            <label htmlFor='dataVisita' className="text-nowrap">Data da visita à unidade</label>
                            <Flatpickr
                                id='dataVisita'
                                value={dataVisita}
                                onChange={([selectedDate]) => setDataVisita(selectedDate)}
                                options={{
                                    dateFormat: "d/m/Y",
                                    locale: Portuguese
                                }}
                                className="form-control"
                                required
                            />
                        </div>
                        <div className='col-12 col-md-2'>
                            <label htmlFor='mesReferencia' className="text-nowrap">Mês de referência</label>
                            <DataMes
                                id='mesReferencia'
                                mes={mesReferencia}
                                setData={setMesReferencia}
                                getUltimoDia={false}
                            />
                        </div>
                        <div className='w-100'>
                            <label htmlFor='unidade' className="text-nowrap">Unidade</label>
                            <BarraBuscaComTodasUnidades
                                setEstabelecimento={setEstabelecimento}
                                somenteAtivos={true}
                                enviaRelatorioAcompanhamento={true}
                            />
                        </div>
                    </div>
                </div>
                {estabelecimento && envioValido && mesReferencia ? (
                    <div>
                        <p>Este documento destina-se ao registro da visita "in loco" à unidade de saúde, afim de monitorar a execução da parceria, objeto do contrato. Cada item deverá ser identificado como SIM, NÃO E PARCIAL (N.A. quando não pertinente ao objeto). Utilizar o campo de OBSERVAÇÕES para fazer considerações sobre as fragilidades apontadas, se necessário, complementados com os ANEXOS DE APOIO.</p>
                        <div className='d-flex flex-column gap-3'>
                            {perguntasAgrupBloco && opcoesRespostas &&
                                perguntasAgrupBloco.map((blocoPerguntas) => (
                                    <BlocoEItensFormularioAcompanhamento
                                        key={blocoPerguntas.blocoId}
                                        blocoPerguntas={blocoPerguntas}
                                        opcoesRespostas={opcoesRespostas}
                                        respondeItem={respondeItem}
                                    />
                                ))}
                        </div>
                        <div className='d-flex flex-column gap-2 mt-2'>
                            <p>*344/1998 estabelece que os medicamentos e substâncias sob controle especial devem ser guardados sob chave ou outro dispositivo que ofereça segurança, portanto, independentemente da solução utilizada pelo estabelecimento, a mesma não pode permitir o acesso aos produtos/ insumos por pessoas não autorizadas (acesso restrito)						</p>
                            <p>**RDC nº 2/2010 determina que a Unidade deve ter um planejamento de manutenção e o monitoramento do desempenho de equipamentos ativos, desenvolvido por técnicos. 						</p>
                            <div>
                                <p>RESUMO DAS FRAGILIDADES DETECTADAS - Apontar considerando o observado nos itens acima</p>
                                <textarea className="w-100 form-control form-control-sm" name="resumoFragilidadesDetectadas" maxLength={600} />
                            </div>
                            <div>
                                <AssinaturasFormularioAcompanhamento
                                    assinaturas={assinaturas}
                                    setAssinaturas={setAssinaturas}
                                    limitMax={regrasDeNegocio.LIMITE_ASSINATURAS_MAX}
                                    limitMin={regrasDeNegocio.LIMITE_ASSINATURAS_MIN}
                                />
                            </div>
                        </div>
                        <button className='btn btn-primary' type='submit'>Enviar</button>
                    </div>
                )
                    :
                    (<div className='d-flex justify-content-center'>
                        <p className='fw-bold mt-3'> ** Selecione um Estabelecimento/Unidade e o Mês de Competência para listar as perguntas ** </p>
                    </div>)
                }
            </form>
        </div>
    );
}

export default CriaFormularioAcompanhamento
